import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, concatMap, from, of } from 'rxjs';
import { COTIZACION_PAUSA, LOADER_MOTO } from '../../../../routes.constans';
import { LeadsService } from '../../../../services/Leads/leads.service';
import { ButtonComponent } from '../../../components/button/button.component';
import { UploadFileService } from '../../../services/onerous/uploadfile.service';
//import { StorageService } from '../../../services/storage.service';
import { CurrencyFormatterDirective } from '../../../../directives/currency-formatter.directive';
import { getFromStorage, getSessionId, saveToStorage } from '../../../../helpers/storageUtils';
import { LeadResponse } from '../../../../Models/leadResponse';
import { DataLayerService } from '../../../../services/DataLayer/data-layer.service';
import { ExceptionService } from '../../../../services/excepciones/exception.service';
import { UtmHandlerService } from '../../../services/utm-handler.service';
import { reqUploadFile, UploadedFile } from '../../interfaces/new-vehicle/new-vehicle.interface';
import { FileUploadComponent } from '../file-upload/file-upload.component';

@Component({
  selector: 'app-new-vehicle',
  templateUrl: './new-vehicle.component.html',
  styleUrl: './new-vehicle.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonComponent,
    FileUploadComponent,
    CurrencyFormatterDirective,
  ],
})
export class NewVehicleComponent implements OnInit {
  /** SERVICIOS */
  //storageService = inject(StorageService);
  utmHandlerService = inject(UtmHandlerService);
  router = inject(Router);
  leadService = inject(LeadsService);
  uploadFileService = inject(UploadFileService);
  private dataLayerService = inject(DataLayerService);
  exceptionsService = inject(ExceptionService);
  /** VARIABLES */
  vehicleValue = signal<string | number | undefined>('');
  accesoriesValue = signal<string | number>('');
  showError = signal<boolean>(false);
  labelError = signal<boolean>(false);
  // Computed: Validar si el formulario es válido
  isFormValid = computed(() => {
    console.log(
      'Computando si es un formulario válido',
      this.vehicleValue() !== '' && this.vehicleValue() !== undefined,
    );
    return this.vehicleValue() !== '' && this.vehicleValue() !== undefined;
  });
  filesToSend = signal<UploadedFile[]>([]);
  OnerousValue = signal('');
  disableSubmitButton = signal<boolean>(false);
  errorMessage = signal<string>('Revisa el valor ingresado.');

  updatedLeadData = getFromStorage<any>('UpdatedLeadData', 'session') || {};

  accesoriesValueFromStorage = getFromStorage('accesoriesValue', 'session') || '';
  totalValue = signal<string>('');
  ceroKmPlusAccesoriesValue = signal<string | number | null>(0);
  isGreaterThanTenPercent = false;
  sessionId = '';
  UpdatedLeadData = getFromStorage<any>('UpdatedLeadData', 'session') || {};
  codigoAsesor: string | undefined;

  ngOnInit(): void {
    this.OnerousValue.set(getFromStorage('OnerousSelection', 'session') || '');

    if (this.accesoriesValueFromStorage) {
      this.accesoriesValue.set(getFromStorage('accesoriesValue', 'session') || '');
    }

    this.sessionId = getSessionId().toString();
  }

  handleValueChange(event: Event) {
    const totalValue = event.toString() || Number(event);
    const {
      Vehiculo: { ValorAseguradoRunt: ValorAsegurado },
    } = this.updatedLeadData;
    const fiftyPercent = ValorAsegurado ? Number(ValorAsegurado) * 0.5 : 0;
    console.log('Valor Asegurado RUNT:', fiftyPercent);

    if (fiftyPercent > Number(totalValue)) {
      console.log('50% del valor asegurado:', fiftyPercent > Number(totalValue));
      this.vehicleValue.set(undefined);
      this.showError.set(true);
      this.labelError.set(true);
      this.errorMessage.set(`Revisa el valor ingresado.`);

      return;
    }

    if (this.OnerousValue() === '0KMAccesorios') {
      const totalAccessoriesValue = this.accesoriesValue();
      const tenPercent = Number(totalValue) ? Number(totalValue) * 0.1 : 0;

      if (
        totalValue !== '' &&
        fiftyPercent <= Number(totalValue) &&
        tenPercent < Number(totalAccessoriesValue)
      ) {
        this.isGreaterThanTenPercent = true;
      } else {
        this.isGreaterThanTenPercent = false;
      }
    }

    if (!totalValue || totalValue === null) {
      this.showError.set(true);
      this.labelError.set(true);
      this.vehicleValue.set('');
      this.errorMessage.set(`Este campo es obligatorio.`);
      return;
    }

    this.showError.set(false);
    this.labelError.set(false);
    this.vehicleValue.set(totalValue);

    this.totalValue.set(String(totalValue));
    const vehiclePlusAccesoriesValue =
      Number(this.accesoriesValue()!) + Number(String(totalValue).replace(/[^0-9.-]+/g, ''));
    this.ceroKmPlusAccesoriesValue.set(vehiclePlusAccesoriesValue);
  }

  handleFilesUploaded(files: UploadedFile[]) {
    console.log('Archivos subidos recibidos en NewVehicleComponent:', files);
    this.filesToSend.set(files);
  }

  onSubmit(): void {
    this.dataLayerService.pushDataLayerOnerous('Button', 'moto_ecommerce_step_2.2_0km', '0km');
    const data = getFromStorage<LeadResponse>('LeadResponse', 'session');
    if (!this.isFormValid()) return;

    console.log('Archivos en base64 para enviar:', this.filesToSend());

    if (this.filesToSend().length > 0) {
      this.handleFilesSequentially(this.filesToSend());
    }

    if (this.isGreaterThanTenPercent) {
      this.handleExceptionsForAccessoriesLead();
      return;
    }

    const reqData = this.buildZeroKMRequest();
    this.leadService
      .UpdateInfoLead(reqData, data?.data?.Id)
      .pipe(
        catchError((error) => {
          console.error('Error no bloqueante actualizando 0KM lead:', error);
          return of({ success: false, data: null });
        })
      )
      .subscribe((response) => {
        const infoToPass = response?.data || this.updatedLeadData || {};
        this.handleRoute(this.OnerousValue(), infoToPass);
      });
  }

  private handleExceptionsForAccessoriesLead() {
    const ExceptionData = {
      required_status: '',
      percentege_lead: 0,
    };

    const urlParams = new URLSearchParams(window.location.search);

    this.codigoAsesor = urlParams.get('codigoAsesor') || '';

    ExceptionData.percentege_lead = 45;
    ExceptionData.required_status = 'Accesorios supera valor';

    this.exceptionsService
      .addExceptionNew(
        this.sessionId,
        this.UpdatedLeadData.lead_id || '',
        ExceptionData.required_status,
        ExceptionData.percentege_lead,
        'Habilitado',
      )
      .subscribe((response) => {
        if (response.data.Success === true) {
          this.codigoAsesor
            ? this.router.navigate([COTIZACION_PAUSA], {
              queryParams: { codigoAsesor: this.codigoAsesor },
            })
            : this.router.navigate([COTIZACION_PAUSA]);
        }
      });
  }

  handleRoute(onerousValue: string, info?: unknown) {
    if (onerousValue === '0KM') {
      saveToStorage('ceroKmInformation', info, 'session');
      this.router.navigate([LOADER_MOTO], { skipLocationChange: true });
      return;
    }

    if (onerousValue === '0KMAccesorios') {
      saveToStorage('ceroKmInformation', info, 'session');
      console.log('Llevaría a la página de accesorios', this.vehicleValue());
      saveToStorage('vehicleValue', this.vehicleValue(), 'session');
      saveToStorage('vehiclePlusAccesoriesValue', this.ceroKmPlusAccesoriesValue(), 'session');
      this.router.navigate([LOADER_MOTO], { skipLocationChange: true });
      return;
    }

    if (onerousValue === '0KMPrenda' || onerousValue === 'full') {
      saveToStorage('ceroKmInformation', info, 'session');
      this.router.navigate([LOADER_MOTO]);
      return;
    }

    saveToStorage('ceroKmInformation', info, 'session');
    this.router.navigate([LOADER_MOTO]);
  }

  private buildZeroKMRequest() {
    //const data = this.storageService.getLeadData();
    const data = getFromStorage<LeadResponse>('LeadResponse', 'session');

    const updatedZeroKMData = {
      lead_id: data?.data?.Id || '',
      accept_tos: data?.data?.lead?.accept_tos ?? true,
      OKM: true,
      ValorVehiculo: this.vehicleValue(),
      set_utm_campaign: this.utmHandlerService.getUtmParams()['utm_campaign'] || '',
      set_utm_content: this.utmHandlerService.getUtmParams()['utm_content'] || '',
      set_utm_medium: this.utmHandlerService.getUtmParams()['utm_medium'] || '',
      set_utm_source: this.utmHandlerService.getUtmParams()['utm_source'] || '',
    };

    return updatedZeroKMData;
  }

  private handleFilesSequentially(files: UploadedFile[]) {
    const completedFiles = files.filter((f) => f.status === 'completed');

    from(completedFiles)
      .pipe(concatMap((archivo) => this.sendFiles(archivo)))
      .subscribe({
        next: (response) => console.log('Archivo enviado:', response),
        error: (error) => console.error('Error:', error),
        complete: () => console.log('Todos los archivos enviados'),
      });
  }

  //REEMPLAZAR POR EL SERVICIO QUÉ PROCESA LOS ARCHIVOS.
  private async sendFiles(file: any) {
    //const leadData = getFromStorage<LeadResponse>('LeadResponse', 'session');

    const leadId = String(getFromStorage('LeadId', 'session'));
    const format = file.mimeType.split('/')[1];

    const RequestCeroKM: reqUploadFile = {
      recordId: leadId,
      fileType: 'Factura0KM',
      fileFormat: format,
      fileBase64: file.base64,
    };

    console.log('Request Cero Km', RequestCeroKM);
    this.uploadFileService.uploadFiles(RequestCeroKM).subscribe((response) => {
      console.log('Respuesta del servicio de subida de archivos:', response);
    });
  }

  handleDisabledButton(event: boolean): void {
    this.disableSubmitButton.set(event);
  }

  validateNumber(event: any) {
    // Guardar solo números en el input y en la variable
    const value = event.target.value.replace(/[^0-9]/g, '');
    this.vehicleValue.set(value);
    event.target.value = value;
  }
}
